import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { PageHead, inp } from "../../components/admin/AdminBits";
import { PanelBottom } from "lucide-react";
import { toast } from "sonner";

export default function AdminFooterPages() {
  const [pages, setPages] = useState([]);
  const load = () => api.get("/admin/pages").then(({ data }) => setPages(data));
  useEffect(() => { load(); }, []);

  const update = async (p, patch) => { await api.put(`/admin/pages/${p.id}`, patch); load(); };

  return (
    <div data-testid="admin-footer-pages">
      <PageHead title="Footer страници" desc="Изберете кои страници да се показват във футъра и в какъв ред. Създавайте страници в меню „Страници“." />
      <div className="bg-white border border-stone">
        <table className="w-full text-sm">
          <thead className="bg-stone text-navy"><tr><th className="text-left p-3">Страница</th><th className="text-left p-3">Във footer</th><th className="text-left p-3">Ред</th></tr></thead>
          <tbody>
            {pages.map((p) => (
              <tr key={p.id} className="border-t border-stone" data-testid={`fp-${p.slug}`}>
                <td className="p-3 text-navy font-medium flex items-center gap-2"><PanelBottom size={14} className="text-gold" />{p.title}</td>
                <td className="p-3"><input type="checkbox" checked={!!p.in_footer} onChange={(e) => update(p, { in_footer: e.target.checked })} className="accent-[#C6A45C] w-4 h-4" data-testid={`fp-toggle-${p.slug}`} /></td>
                <td className="p-3"><input type="number" defaultValue={p.order} onBlur={(e) => update(p, { order: parseInt(e.target.value) || 99 })} className={`${inp} w-20`} /></td>
              </tr>
            ))}
            {pages.length === 0 && <tr><td colSpan={3} className="p-4 text-charcoal/50">Няма страници. Създайте в меню „Страници".</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
